import React from 'react'
import PropTypes from 'prop-types'
import './MoneyByMonth.scss'
import MoneyMonthLineChart from '../components/moneyMonthLineChart/MoneyMonthLineChart'
const rootClassName = 'component-money-by-month'

export default function MoneyByMonth(props) {
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-caption ${rootClassName}-caption-left`}>
        {props.leftCaption}
      </div>
      <div
        className={`${rootClassName}-caption ${rootClassName}-caption-right`}
      >
        {props.rightCaption}
      </div>
      <div className={`${rootClassName}-chart`}>
        <MoneyMonthLineChart data={props.data} labels={props.labels} />
      </div>
    </div>
  )
}

MoneyByMonth.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number),
  leftCaption: PropTypes.string,
  rightCaption: PropTypes.string,
  labels: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )
}

MoneyByMonth.defaultProps = {
  data: [],
  labels: [
    'jan',
    'fev',
    'mar',
    'abr',
    'mai',
    'jun',
    'jul',
    'ago',
    'set',
    'out',
    'nov',
    'dez'
  ]
}
